var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEko02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "302.95mm",
    height: "302.95mm",
    viewBox: "0 0 858.76 858.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.38,23.96c54.74,0,107.83,10.72,157.8,31.85,48.27,20.42,91.63,49.65,128.87,86.89s66.48,80.6,86.89,128.87c21.13,49.97,31.85,103.06,31.85,157.8s-10.72,107.83-31.85,157.8c-20.42,48.27-49.65,91.63-86.89,128.87-37.24,37.24-80.6,66.48-128.87,86.89-49.97,21.13-103.06,31.85-157.8,31.85s-107.83-10.72-157.8-31.85c-48.27-20.42-91.63-49.65-128.87-86.89-37.24-37.24-66.48-80.6-86.89-128.87-21.13-49.97-31.85-103.06-31.85-157.8s10.72-107.83,31.85-157.8c20.42-48.27,49.65-91.63,86.89-128.87s80.6-66.48,128.87-86.89c49.97-21.13,103.06-31.85,157.8-31.85m0-22C193.33,1.96,1.96,193.33,1.96,429.38s191.36,427.42,427.42,427.42,427.42-191.36,427.42-427.42S665.44,1.96,429.38,1.96h0Z",
    fill: "#62b578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M499.18,310.36c-60.37-135.81-17.79-206.01-17.79-206.01,0,0-112.73,101.44-132,192.55-14.24,67.35,33.61,131.09,97.93,140.76,64.31,9.66,79.82-64.4,51.86-127.3Z",
    fill: "#62b578"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M499.58,538.95c9.99-10.87,26.32-13.65,40.95-11.7,14.63,1.95,28.4,7.86,42.61,11.86,14.21,4,29.84,6,43.43,.24-16.29-13.11-34.39-24.65-54.68-29.7s-43.1-2.91-60.02,9.37c-16.21,11.77-25.14,31.02-39.3,45.19",
    fill: "#0f4a4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.9,419.46c-21.67-3.9-44-2.26-65.68,1.58-19.47,3.45-39.77,8.62-58.61,2.63,21.27-24.81,53.1-40.24,85.75-41.57,11.21-.46,22.57,.7,33.22,4.22,15.5,5.13,45.02,21.85,51.3,38.17,5.1,13.24-2.61,10.53-12.23,6.6-11.32-4.63-21.54-9.44-33.75-11.64Z",
    fill: "#0f4a4f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.69,421.39s57.87-20.08,111.49,17.62c55.46,38.99,106.7,98.93,113.8,48,7.1-50.94-41.57-99.82-108.71-109.19-67.14-9.37-116.59,43.57-116.59,43.57Z",
    fill: "#62b578"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M447.32,437.66c5.52,18.75-4.11,33.88-15.48,49.77-11.37,15.9-25.64,30.06-33.37,48.01-7.33,17.02-8.12,36.77-2.15,54.31,5.89,17.33,17.85,31.97,24.97,48.84,11.53,27.33,10.34,51.45-5.02,76.83",
    fill: "none",
    stroke: "#62b578",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8.73
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M429.38,856.8c70.1,0,136.25-16.87,194.62-46.78-30.82-77.29-106.34-131.91-194.62-131.91s-163.8,54.62-194.62,131.91c58.37,29.91,124.53,46.78,194.62,46.78Z",
    fill: "#62b578"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M367.99,501.22c12.64,18.19,21.16,39.23,24.76,61.08",
    fill: "none",
    stroke: "#62b578",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8.73
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M618.52,532.51s-42.81-18.74-85.85,6.73c-44.51,26.34-87.06,68.86-89.42,29.7-2.36-39.16,37.58-73.43,89.21-76.54,51.62-3.11,86.06,40.11,86.06,40.11Z",
    fill: "#62b578"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M450.79,578.68c-14.03,17.15-24.17,37.45-29.47,58.96",
    fill: "none",
    stroke: "#62b578",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8.73
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEko02);
export default __webpack_public_path__ + "static/media/eko-02.b432829ec24e642da21c07d2917919af.svg";
export { ForwardRef as ReactComponent };